import {
  OreButton,
  OreCheckbox,
  OreHeading,
  OreStack,
  OreText,
  OreTooltip,
  SvgCheck,
  SvgDownload,
} from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AutoEnrollmentDocumentModel } from '@/AutoEnrollment/domain'
import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { useAutoEnrollment } from '@/AutoEnrollment/ui/context'
import { Step3Form } from '@/AutoEnrollment/ui/hooks'
import { textToPdf } from '@/Shared/domain'
import { handleErrors } from '@/Shared/ui/form'

export const Step3SignDocuments = (): JSX.Element => {
  const { t } = useTranslation()

  const { register, formState, getValues } = useFormContext<Step3Form>()
  const { errors } = handleErrors(formState)

  const {
    documents: { documents, setIsDownloaded, isProductDisabled, dowloadedDocuments },
  } = useAutoEnrollment()

  const documentButton = (
    documentToSign: AutoEnrollmentDocumentModel,
    i: number,
  ): JSX.Element => {
    const disabled = isProductDisabled(
      documentToSign.documentProduct,
      getValues('products'),
    )

    const isDownloaded = dowloadedDocuments.find(
      d => d.signingId === documentToSign.signingId,
    )?.signed

    if (disabled) {
      return (
        <OreTooltip
          text={t(
            AutoEnrollmentTranslation.productsConditions.signDocuments.signBlock.label,
          )}
          placement="right"
          key={`document-to-sign-${i}`}
        >
          <OreButton
            onClick={() => {
              textToPdf(
                documentToSign.documentContent,
                documentToSign.documentName.split('.').slice(0, -1).join('.'),
              )
              setIsDownloaded(documentToSign.signingId)
            }}
            icon={isDownloaded ? <SvgCheck /> : <SvgDownload />}
            disabled={disabled}
          >
            {documentToSign.documentName.split('.').slice(0, -1).join('.')}
          </OreButton>
        </OreTooltip>
      )
    }

    return (
      <OreButton
        key={`document-to-sign-${i}`}
        onClick={() => {
          textToPdf(
            documentToSign.documentContent,
            documentToSign.documentName.split('.').slice(0, -1).join('.'),
          )
          setIsDownloaded(documentToSign.signingId)
        }}
        icon={isDownloaded ? <SvgCheck /> : <SvgDownload />}
      >
        {documentToSign.documentName.split('.').slice(0, -1).join('.')}
      </OreButton>
    )
  }

  return (
    <OreStack space="large">
      <OreHeading size="headline-md">
        {t(AutoEnrollmentTranslation.productsConditions.signDocuments.title)}
      </OreHeading>
      <OreText>
        {t(AutoEnrollmentTranslation.productsConditions.signDocuments.description)}
      </OreText>
      <OreStack placeItems="start">
        {documents?.documentsForSigning?.map(
          (document: AutoEnrollmentDocumentModel, i: number) => {
            if (!document.needsSign) return null

            return documentButton(document, i)
          },
        )}
      </OreStack>
      <OreCheckbox
        {...register('isIAERestaurant')}
        {...errors('isIAERestaurant')}
        label={t(
          AutoEnrollmentTranslation.productsConditions.signDocuments.acceptIAE.label,
        )}
        required
      />
    </OreStack>
  )
}
